export const indexCopy = {
  // The index page copy lives at index2.ts
  index_releases: "Versions trimestrielles",
  index_releases_pt1: "Notre prochaine version est ",
  index_releases_pt2: ", qui est prévue pour ",
  index_releases_released: "Publiée",
  index_releases_beta: "Bêta",
  index_releases_rc: "RC"
}
